import { render, staticRenderFns } from "./classHourEmpower.vue?vue&type=template&id=4597d5f4&"
import script from "./classHourEmpower.vue?vue&type=script&lang=js&"
export * from "./classHourEmpower.vue?vue&type=script&lang=js&"
import style0 from "./classHourEmpower.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports